import {fileInputType, FileInputRenderer} from './File'

class CustomFormFields {
    constructor(formFields) {
      formFields.register(fileInputType, FileInputRenderer);
    }
  }
  
  export default {
    __init__: ['fileInputField'],
    fileInputField: ['type', CustomFormFields]
  };